import { defineComponent, ref, onMounted, onUnmounted, openBlock, createElementBlock, createElementVNode, normalizeClass, createVNode, unref, withCtx, createTextVNode } from "vue";
import { CdrButton, IconXLg, IconXSm, CdrIcon, IconChat } from "@rei/cedar";
import { useIntersectionObserver } from "../../../composables/IntersectionObserver/useIntersectionObserver.mjs";
const _hoisted_1 = {
  class: "expertise-chat__img-container"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ExpertiseChatV2",
  emits: ["initGladlyChat", "callGladlyChat", "metricsClick"],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const rootRef = ref();
    const opensCount = ref(0);
    const observer = ref();
    const openExpertiseChatDialog = ref(false);
    const openDialog = () => {
      if (opensCount.value < 1) {
        openExpertiseChatDialog.value = true;
      }
      opensCount.value += 1;
    };
    const closeDialog = (track = true) => {
      openExpertiseChatDialog.value = false;
      if (track) {
        emit("metricsClick", {
          linkName: "help:sidekick_dismiss"
        });
      }
    };
    onMounted(() => {
      const {
        addIntersectionAction
      } = useIntersectionObserver();
      if (rootRef.value) {
        addIntersectionAction(rootRef.value, (entry) => {
          if (entry.isIntersecting) {
            openDialog();
          }
        });
      }
    });
    onUnmounted(() => {
      var _a;
      if (rootRef.value) {
        (_a = observer.value) == null ? void 0 : _a.unobserve(rootRef.value);
      }
    });
    const onCtaClicked = () => {
      closeDialog(false);
      emit("metricsClick", {
        linkName: "help:sidekick_open_startchatnow"
      });
      emit("callGladlyChat");
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("section", {
        ref_key: "rootRef",
        ref: rootRef
      }, [createElementVNode("section", {
        class: normalizeClass(["expertise-chat__container", {
          open: openExpertiseChatDialog.value
        }])
      }, [createVNode(unref(CdrButton), {
        class: "expertise-chat__close-button",
        tabindex: openExpertiseChatDialog.value ? 0 : -1,
        "icon-only": true,
        "with-background": false,
        "aria-label": "Close",
        onClick: closeDialog
      }, {
        icon: withCtx(() => [createVNode(unref(IconXLg), {
          class: "expertise-chat__close-button-icon-lg",
          size: "large"
        }), createVNode(unref(IconXSm), {
          class: "expertise-chat__close-button-icon-sm",
          size: "large"
        })]),
        _: 1
      }, 8, ["tabindex"]), createElementVNode("div", _hoisted_1, [_cache[1] || (_cache[1] = createElementVNode("img", {
        class: "expertise-chat__img",
        src: "https://public.cloud-dam.rei.com/api/public/content/f9f2a982d54d4991b67be83d8dfbb709",
        alt: "picture of a girl hiking in iceland"
      }, null, -1)), createVNode(unref(CdrIcon), {
        class: "expertise-chat__icon"
      }, {
        default: withCtx(() => [_cache[0] || (_cache[0] = createElementVNode("title", null, "Thinking globe", -1)), createVNode(unref(IconChat))]),
        _: 1,
        __: [0]
      })]), _cache[3] || (_cache[3] = createElementVNode("div", {
        class: "expertise-chat__information"
      }, [createElementVNode("h2", {
        class: "expertise-chat__header"
      }, " Need help choosing gear? "), createElementVNode("text", {
        class: "expertise-chat__text"
      }, " Get real advice from our experts who have been there, done that. ")], -1)), createVNode(unref(CdrButton), {
        modifier: "primary",
        size: "medium",
        class: "expertise-chat__button",
        "data-ui": "call-gladly-chat",
        onClick: onCtaClicked
      }, {
        default: withCtx(() => [createVNode(unref(IconChat), {
          class: "expertise-chat__button-icon"
        }), _cache[2] || (_cache[2] = createTextVNode(" Start chat now "))]),
        _: 1,
        __: [2]
      })], 2)], 512);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=ExpertiseChatV22.mjs.map
